<div class="row">
    <div class="col-md-12 pl-4">
        <yt-fw-default-update-buttons #defaultUpdateButtons></yt-fw-default-update-buttons>

        <!-- <div class="btn-group ml-1">
            <button class="btn btn-outline-primary" type="button">
                <span class="fa fa-fw fa-print"></span>Štampaj dokument
            </button>

            <button class="btn btn-outline-primary" type="button">
                <span class="fa fa-fw fa-print"></span> Za knjigovođu
            </button>
        </div> -->
    </div>
</div>
<yt-pravo-na-go-update #baseUpdate></yt-pravo-na-go-update>
